import {qrCodeSvg as Icon__small__qrCodeSvg} from '../Icon__small/Icon__small--qrCode.js'

export var qrCode = {
  name: 'qrCode',
  category: 'icon',
  colorable: true,
  svg: Icon__small__qrCodeSvg,
};
